/**
 * Maps v2 `{ data: { user } }` payloads to the profile shape used in Redux.
 * @param {{ data?: { user?: Record<string, unknown> } } | null | undefined} response
 * @returns {Record<string, unknown>}
 */
export function mapUserProfileFromResponse(response) {
  const user = response?.data?.user;
  if (!user) return response;
  return {
    ...user,
    avatar: user.image ?? user.avatar ?? null,
  };
}
